import React from "react";
import { Link } from "react-router-dom";
import { toAbsoluteUrl } from "../../../_helpers";
import {getConfig} from "../../../i18n";
import {roles} from "../../../../index";



export function Brand() {
  const {role} = getConfig();

  const logoApp = {
    [roles.provider]: "logo-letter-secondary.png",
    [roles.client]: "logo-letter-primary.png",
    [roles.super_admin]: "logo-letter-primary.png",
    [roles.visitor]: "logo-dark.png",
  }


  return (
    <>
      {/* begin::Brand */}
      <div
        className={`aside-brand d-flex flex-column align-items-center flex-column-auto py-5 py-lg-12 s`}
      >
        {/* begin::Logo */}
        <Link to="" className="brand-logo">
          <img
            alt="logo"
            src={toAbsoluteUrl(`/media/logos/${logoApp[role]}`)}
            className={`max-h-30px`}
          />
        </Link>
        {/* end::Logo */}
      </div>
      {/* end::Brand */}
    </>
  );
}
